import {
  CustomerThreeYearsStatisticsInput,
  CustomerThreeYearsStatisticsQuery,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { useNegotiationYears } from "../../../contexts/NegotiationYearGate";

const query = gql`
  query customerThreeYearsStatistics(
    $customerNumber: Int!
    $currencyCode: String!
    $year: Int!
  ) {
    productPrice {
      customerStatistics {
        customerThreeYearsStatistics(
          input: {
            customerNumber: $customerNumber
            currencyCode: $currencyCode
            year: $year
          }
        ) {
          actualRate
          customerNumber
          diffPreviousYear
          expectedVolume
          id
          last12MonthsVolume
          negotiationStatus
          pricePerMeter
          targetRate
          year
        }
      }
    }
  }
`;

export const usecustomerThreeYearsStatistics = (
  customerId: string,
  currencyCode: string
) => {
  const { defaultYear } = useNegotiationYears();
  const { loading, data } = useQuery<
    CustomerThreeYearsStatisticsQuery,
    CustomerThreeYearsStatisticsInput
  >(query, {
    variables: {
      customerNumber: parseInt(customerId),
      currencyCode,
      year: defaultYear,
    },
  });

  return {
    loading,
    threeYearsStatistics:
      data?.productPrice.customerStatistics.customerThreeYearsStatistics,
  };
};
